export enum ElementTypeEnum {
    Text = 'Text',
    Number = 'Number'
}